<template>
  <div id="app">
    <keep-alive :include="include">
      <router-view @error="showError" />
    </keep-alive>
    <transition name="fadeapp" @after-leave="afterLeaveapp">
      <div v-show="showcountDownTimeapp" class="count-time">
        {{ countDownTimeapp }}
      </div>
    </transition>
    <div class="count-time-back" v-if="isShowtimeback"></div>
    <popUpDisplay :show.sync="popUpDisplay.dialog" :activityPrize="popUpDisplay.activityPrize" :type="popUpDisplay.type"
      @clickClose="clickClose"></popUpDisplay>
  </div>
</template>

<script>
import activityApi from '@/api/activity'
import popUpDisplay from './components/popup-cards.vue'
export default {
  name: 'App',
  components: {
    popUpDisplay
  },
  data() {
    return {
      include: ['home-main'],
      countDownTimeapp: '',
      timerCountDown: '', // 倒计时定时器
      showcountDownTimeapp: false, // 展示倒计时
      routerStatus: '', // 获取上级路由的信息
      failure: '', // 判断是否已完成计时
      // againGo: false, // 是否多次进入
      isShowtimeback: false,
      popUpDisplay: {
        dialog: false,
        activityPrize: {},
        type: 'watch'
      }
    }
  },
  watch: {
    countDownTimeapp: {
      handler(newVal, oldVal) {
        if (newVal === 0 && this.failure === '1') {
          clearInterval(this.timerCountDown)
          this.timeFinshCoupon()
        }
        if (newVal < 0 && this.failure === '1') {
          clearInterval(this.timerCountDown)
          this.isShowtimeback = false
        }
      },
      immediate: true
    }
  },
  mounted() {
    // 通过on监听事件,回调方法获取数据
    this.$bus.on('lowerRight', value => {
      if (value === 1) {
        this.failure = '1'
        this.isShowtimeback = true
        this.countDownTimeapp = 15
        this.startcountDownTimeapp()
      } else {
        this.isShowtimeback = false
        this.showcountDownTimeapp = false
        clearInterval(this.timerCountDown)
        this.countDownTimeapp = ''
      }
    })
  },
  methods: {
    clickClose() {
      this.popUpDisplay.dialog = false
    },
    showError(val) {
      // console.log(val)
      if (!val.errorMsg) {
        return
      }
      this.$notify({
        message: val.errorMsg,
        background: 'rgba(255, 68, 68, 0.9)',
        className: 'notify-error-msg'
      })
    },
    // 查询是否已经完成倒计时
    queryIsfinsh() {
      activityApi.timeQuery().then(res => {
        if (res.data.resultData.timing === '1') {
          this.failure = res.data.resultData.timing
          // this.failure = "1"
          this.isShowtimeback = true
          this.countDownTimeapp = 15
          this.startcountDownTimeapp()
        } else {
          this.isShowtimeback = false
          this.showcountDownTimeapp = false
          clearInterval(this.timerCountDown)
          this.countDownTimeapp = ''
        }
      })
    },
    // 完成15s倒计时接口
    // finshCountDown () {
    //   this.isShowtimeback = false
    //   this.showcountDownTimeapp = false
    //   clearInterval(this.timerCountDown)
    //   this.$toast('你已经观看了15s')
    //   activityApi.timeFinsh().then(res => {
    //     if (res.data.resultCode === '0') {
    //       console.log(res.data.success, '倒计时接口调用success')
    //     }
    //   })
    // },
    timeFinshCoupon() {
      this.isShowtimeback = false
      this.showcountDownTimeapp = false
      clearInterval(this.timerCountDown)
      this.$toast('你已经观看了15s')
      activityApi.timeFinshCoupon().then(res => {
        if (res.data.resultCode === '0') {
          if (res.data.resultData.activityPrize) {
            this.popUpDisplay.dialog = true
            this.popUpDisplay.activityPrize = res.data.resultData.activityPrize
          }
        }
      })
    },
    // 浏览倒计时 15s
    startcountDownTimeapp() {
      if (this.countDownTimeapp > 0) {
        console.log('开始倒计时')
        this.showcountDownTimeapp = true
        this.timerCountDown = setInterval(() => {
          this.countDownTimeapp--
          // this.showcountDownTimeapp = !this.showcountDownTimeapp
        }, 1000)
      }
    },
    // 淡入淡出效果结束调用
    afterLeaveapp() {
      this.countDownTimeapp--
    }
  }
}
</script>
<style lang="less">
.layer_bg {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  background-color: rgba(0, 0, 0, .8);
  z-index: 99;

  .layer_d {
    width: 290px;
    background: radial-gradient(258.12% 128.52% at 3.14% 89.66%, #FFF 0%, #CBF7FF 86.78%, #CBF7FF 96.7%);
    display: flex;
    align-items: center;
    flex-direction: column;
    box-sizing: border-box;
    position: relative;
  }
  .layer_bg_img {
    width: 290px;
    height: 283px;
  }

  .layer_pos_bom_btn {
    width: 136px;
    height: 44px;
    border-radius: 58px;
    background: #288090;
    color: #FFF;
    text-align: center;
    font-family: "PingFang SC";
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    bottom: 26px;
  }
  .layer_title {
    margin-top: 32px;
    font-size: 16px;
    margin-bottom: 32px;

  }

  .layer_title2 {
    font-size: 15px;
    margin-bottom: 14px;
    display: flex;
    flex-direction: row;

    p {
      color: #EB5336;

      font-family: "PingFang SC";
      font-size: 16px;
    }
  }

  .layer_title3 {
    color: #71767C;
    margin-bottom: 29px;
    display: flex;
    flex-direction: row;
    font-family: "PingFang SC";
    font-size: 13px;

    p {
      color: #EB5336;

      font-family: "PingFang SC";
      font-size: 13px;
    }
  }

  .layer_close {
    width: 32px;
    height: 32px;
    margin-top: 24px;
  }

  .layer_btn {
    width: 136px;
    height: 44px;
    border-radius: 58px;
    background: #288090;
    color: #FFF;
    text-align: center;
    font-family: "PingFang SC";
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 26px;
  }

}

.van-dialog__confirm,
.van-dialog__confirm:active {
  color: #007BC0 !important;
}

#app {
  height: 100%;
  font-family: 'PingFang SC-Regular Microsoft YaHei';
  font-size: 14px;

  .fadeapp-enter-active,
  .fadeapp-leave-active {
    transition: opacity .1s
  }

  .fadeapp-enter,
  .fadeapp-leave-to {
    opacity: 0;
  }

  .count-time {
    position: fixed;
    // top: 41.5%;
    top: 69.8%;
    right: 4.4%;
    text-align: center;
    width: 30px;
    height: 30px;
    line-height: 30px;
    font-size: 16px;
    // font-style: italic;
    // font-weight: bold;
    color: #117281;
    z-index: 999;
  }

  .count-time-back {
    position: fixed;
    // top: 40%;
    top: 68%;
    right: 0;
    width: 58px;
    height: 54px;
    background: url("./assets/images/activity/cards/time-out.png") no-repeat;
    background-size: cover;
    z-index: 99;
  }
}
</style>
